var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokGlyph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3817 0H8.68521V10.8985C8.68521 12.1971 7.64813 13.2638 6.35751 13.2638C5.06689 13.2638 4.02979 12.1971 4.02979 10.8985C4.02979 9.6232 5.04385 8.57969 6.28838 8.53333V5.79711C3.54581 5.84347 1.33333 8.09276 1.33333 10.8985C1.33333 13.7276 3.5919 16 6.38057 16C9.16918 16 11.4278 13.7044 11.4278 10.8985V5.31013C12.4418 6.05218 13.6863 6.49276 15 6.51596V3.77971C12.9719 3.71015 11.3817 2.04058 11.3817 0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokGlyph);
export default __webpack_public_path__ + "static/media/tiktok-glyph.de9a2a5e20b03ad58bc02b76a5b24363.svg";
export { ForwardRef as ReactComponent };